import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import whyDidYouRender from '@welldone-software/why-did-you-render';
import { BrowserRouter } from 'react-router-dom';
// import { AuthProvider } from './context/Context';
// import AntiInspect from './AntiInspect';

console.log("NODE_ENV:", process.env.NODE_ENV);

if (process.env.NODE_ENV === 'development') {
    whyDidYouRender(React, {
        trackAllPureComponents: true,
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                {/* <AuthProvider> */}
                    {/* <AntiInspect /> */}
                    <App />
                {/* </AuthProvider> */}
            </BrowserRouter>
        </Provider>
    // </React.StrictMode>
);
reportWebVitals();
